import React from 'react';
import Layouts from 'layouts';
import OgImage from 'images/promotions/banner-alltopasia-promotion-cover--6.5%-per-week.jpg';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-intl';
import ComponentTemplate from '../../promotion-template/component-template';

const PromotionsPage = (props) => {
  const intl = useIntl();
  const { location } = props;

  return (
    <Layouts
      title={intl.formatMessage({ id: 'page.home.title' })}
      description={intl.formatMessage({ id: 'page.home.description' })}
      image={OgImage}
      pathname={location.pathname}
    >
      <ComponentTemplate
        cover="/2022-9-9-daily-slot-1.jpg"
        title="Daily PG และ Joker ยอดฝากแรกของวัน รับโบนัส 50%'"
        subTitle="ยอดฝาก 100 บาท ขึ้นไป รับโบนัส สูงสุด 500 บาท"
        desc="ต้องทำยอดชนะ 8 เท่า ถึงจะสามารถถอนได้ สามารถถอนได้สูงสุด 100 เท่าของยอดฝาก"
        howto="ยอดฝาก = 100 บาท ยอดโบนัส = 50 บาท ยอดชนะที่ต้องการ = (100 + 50 ) x 8 = 1,200 บาท (ไม่รวมทุน)"
        note="เฉพาะสมาชิกที่โอนเงินเข้า PG หรือ Joker ครั้งแรกของวัน เท่านั้น สมาชิกสามารถรับได้ 1 ครั้ง ต่อวัน เท่านั้น โปรโมชั่นนี้สามารถใช้งานได้เฉพาะเว็บ PG/Joker เท่านั้น"
      />
    </Layouts>
  );
};

PromotionsPage.propTypes = {
  location: PropTypes.string.isRequired,
};

export default PromotionsPage;
